import { render } from "./FeaturesList.vue?vue&type=template&id=1bf03be5&scoped=true"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"

import "./FeaturesList.vue?vue&type=style&index=0&id=1bf03be5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf03be5"]])

export default __exports__